/*!
=========================================================
* Argon Dashboard React - v1.1.0
=========================================================
* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)
* Coded by Creative Tim
=========================================================
* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React from "react";

import firebase from 'firebase/app';

// reactstrap components
import { Card, CardBody, CardTitle, CardText, Container, Row, Col, Form } from "reactstrap";
import withAuthorization from "../withAuthorization";
import { db } from "../../firebase";
import { keys } from "@material-ui/core/styles/createBreakpoints";
//import numInQueue from 
import { Button } from "reactstrap";





 const queueUser=5;


            // let dobobj = Object.values(dataSnapShot.val());
            // for (var i = 0; i < dataSnapShot.numChildren(); i++) {
            //   if (dobobj[i].uid == uid) {
                
            //   }
            // }

            const byPropKey = (propertyName, value) => () => ({
              [propertyName]: value
            });
            

class Header extends React.Component {

  
  state = {
    Firstname:"",
    Lastname:"",
    Major:"",
    Year_Started:"",
    name:" ",
    message:"",
    Student_id:"",
    Advisor:"",
    NUMB:"",
    POS:"",
    office:""
    
  };

  componentDidMount() {
    var user = firebase.auth().currentUser;
    var uid = user.uid;
    var self = this;
    var doblist = firebase.database().ref("Queue");
        doblist.once("value", dataSnapShot => {
          if(dataSnapShot.val() != null){

         // let dobobj = Object.values(dataSnapShot.val());
          let dobkey = Object.keys(dataSnapShot.val());
          for (var i =0  ; i <dataSnapShot.numChildren() ; i++) {
            
            if(dobkey[i] == loggedUser.uid){
            self.setState({
              POS: i+1
            })
          }
          }
            this.setState({
              NUMB: dataSnapShot.numChildren() ,

            })
          }
          else{
            this.setState({
              POS: "0",
              NUMB:"no"
            })
          }
            
        });
     
   
 
    const { loggedUser } = this.props;

   
    db.doGetAnUnser(loggedUser.uid).then(res => {
      this.setState({
        Firstname: res.val().Firstname,
        Lastname: res.val().Lastname,
        Major: res.val().Major,
        Year_Started: res.val().Year_Started,
        
      });
    });


// var doblist = firebase.database().ref("Queue");
// doblist.once("value", dataSnapShot => {
//   for (var i=0; i<dataSnapShot.numChildren(); i++){
//   if(Object.values(dataSnapShot.val()) == uid){
    
db.doGetAppointment(loggedUser.uid).then(res => {
  if(res.val()!=null){
      this.setState({
        name: res.val().name,
        message: res.val().message,
        Student_id: res.val().Student_id,
        Advisor: res.val().Advisor
        
      });
    }
    if(res.val()!=null){
    if (res.val().Advisor == "Linda Barasch"){
      this.setState({
        office: "ERB 643"
      })
    }

    if (res.val().Advisor == "Katy Pedone"){
      this.setState({
        office: "ERB 645"
      })
    }

    if (res.val().Advisor == "Chris Conly"){
      this.setState({
        office: "ERB 642"
      })
    }

    if (res.val().Advisor == "Melissa Rose"){
      this.setState({
        office: "ERB 644"
      })
    }
  }
    
    if(res.val()==null){
      this.setState({
        name: "N/A",
        message: "N/A",
        Student_id: "N/A",
        Advisor: "N/A"
        
      });
    }
    });
  
//   }}
// });



}


  render() {
    const appLocation="ERB 642";
    

    
    const {Firstname, Lastname, Major, Year_Started, name, message, Student_id, Advisor, NUMB,POS, office } = this.state;
   
    
    // console.log("dasdf", this.props.loggedUser);
    return (
      <>
      <div className="header pb-8 pt-md-5">
        <Container fluid>
          <div className="header-body">
            {/* Card stats */}
            <Row>
              <Col lg="6" xl="4">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h3"
                          className="text-uppercase mb-2"
                        >
                          My Information
                        </CardTitle>
                        
                          <div className="h5 font-weight-bold mb-0">
                            <p>Name: {Firstname} {Lastname}
                            <br />Major: {Major}
                            <br />Year: {Year_Started}
                            </p>
                          </div>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-primary text-white rounded-circle shadow icon-lg">
                          <i className="fas fa-address-card" />
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="4">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                        <CardTitle
                          tag="h3"
                          className="text-uppercase mb-2"
                        >
                          My Appointment
                        </CardTitle>
                        <div className="h4 font-weight-bold mb-0">
                            <p>Adviser: {Advisor} (at {message} )
                            <br />Studnet ID: {Student_id}
                            <br />Location: {office}
                            {/* <br />Time: {message} */}

                            </p>
                            
                        </div>
                        
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-info text-white rounded-circle shadow icon-lg">
                          <i className="fas fa-calendar-check" />
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="6" xl="4">
                <Card className="card-stats mb-4 mb-xl-0">
                  <CardBody>
                    <Row>
                      <div className="col">
                      <CardTitle
                          tag="h3"
                          className="text-uppercase mb-2"
                        >
                          Current Queue
                      </CardTitle>
                      <div className="h5 font-weight-bold mb-0">
                            <p>There are {NUMB} people waiting.
                            <br />
                            <br />You are at - {POS} position in the queue.
                            <br />
                            </p>
                          </div>
                      </div>
                      <Col className="col-auto">
                        <div className="icon icon-shape bg-success text-white rounded-circle shadow icon-lg">
                          <i className="fas fa-users" />
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                  
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </>
    );
  }
}
const authCondition = authUser => !!authUser;
export default withAuthorization(authCondition)(Header);
